import palette from "../palette";
const { lightTwo, borderLight } = palette;

const components = {
  MuiCssBaseline: {
    styleOverrides: {
      html: {
        WebkitFontSmoothing: 'auto',
      },

      "*": {
        boxSizing: 'border-box',
      },

      "a:active": {
        textDecoration: 'none'
      },

      'a': {
        textDecoration: 'none',
      },

      body: {
        backgroundColor: '#FFFFFF',

        "& .MuiMenu-paper": {
          maxHeight: '180px'
        },

        "& .notistack-SnackbarContainer": {
          zIndex: '9999999999999999999999999999999999999999 !important',
        },

        "& .SnackbarItem-wrappedRoot": {
          top: '80px !important'
        },

        "& .SnackbarItem-message": {
          letterSpacing: 0
        }
      },
    },
  },

  MuiPopover: {
    styleOverrides: {
      root: {
        zIndex: '99999'
      }
    }
  },

  MuiAutocomplete: {
    styleOverrides: {
      popper: {
        zIndex: '999999',

        "& ul": {
          maxHeight: "10rem",
          paddingTop: '8px',
          paddingBottom: '8px',
          border: `1px solid ${palette.lightGray}`
        }
      }
    }
  },


  MuiChip: {
    styleOverrides: {
      colorSuccess: {
        color: palette.green,
        borderColor: palette.green
      }
    }
  },

  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        fontSize: '16px',
        fontWeight: '400',
        letterSpacing: '0.15px',
        color: 'rgba(0, 0, 0, 0.87)',
        height: '56px',
        borderRadius: '8px',

        "&:hover": {
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: palette.primary.main,
          },

        },

        "&.Mui-focused": {
          "& .MuiOutlinedInput-notchedOutline": {
            borderWidth: '1px',
            borderColor: palette.primary.main,
          }
        },

        '&.Mui-disabled': {
          opacity: 0.5,
        }
      },

      notchedOutline: {
        borderColor: palette.borderLight,
      }
    }
  },

  MuiInputBase: {
    styleOverrides: {
      root: {
        "&:before": {
          borderBottom: '0 !important',
        },
      }
    }
  },

  MuiInputLabel: {
    styleOverrides: {
      root: {
        fontSize: '16px',
        fontWeight: '400',
        letterSpacing: '0.15px',
        color: palette.lightOne
      }
    },
  },

  MuiTableCell: {
    styleOverrides: {
      head: {
        backgroundColor: lightTwo,
        borderBottom: 'none !important',
      },

      body: {
        borderBottom: 'none !important',
      }
    },
  },

  MuiButton: {
    styleOverrides: {
      root: {
        fontSize: '15px',
        padding: '10px 24px',
        fontWeight: '700',
        borderRadius: '8px',
        textTransform: "capitalize" as const,
        boxShadow: 'none',

        "&:hover": {
          boxShadow: 'none',
        },

        containedSecondary: {
          color: palette.white
        }
      },
    },
  },

  MuiStepper: {
    styleOverrides: {
      root: {
        '& .MuiStepLabel-label.Mui-active': {
          color: palette.black,
          fontSize: '14px',
          fontWeight: '400',
        },

        '& .Mui-active svg': {
          color: palette.success.main,
        },

        '& .MuiStepIcon-text': {
          fontSize: '12px'
        },

        '& .MuiStepIcon-root.Mui-completed': {
          color: palette.success.main,
        },

        '& .MuiStepLabel-label.Mui-completed': {
          color: palette.black,
          fontSize: '14px',
        },

        "& .Mui-disabled": {
          color: '#000',
          fontWeight: '400',
          fontSize: '14px',
        },

        "& .Mui-disabled svg": {
          color: palette.lightOne,
          borderRadius: '77px',
        },

        "& .Mui-disabled svg text": {
          fill: palette.white,
        },

        "& .MuiStepConnector-line": {
          borderColor: palette.blackFive
        }
      }
    }
  },

  MuiTabs: {
    styleOverrides: {
      root: {
        '& .MuiTab-root': {
          fontSize: '14px',
          fontWeight: '500',
          color: '#635C72'
        },
        '& .Mui-selected': {
          color: palette.primary.main
        }
      }
    }
  },

  MuiPagination: {
    styleOverrides: {
      root: {
        '& .MuiPaginationItem-page': {
          backgroundColor: palette.white,
          color: palette.black,
          border: `1px solid ${borderLight}`,
          transition: '0.3s',
          "&:hover": {
            border: `1px solid ${palette.primary.main}`,
            backgroundColor: palette.lightTen,
            color: palette.primary.main,
          }
        },
        '& .MuiPaginationItem-page.Mui-selected': {
          border: `1px solid ${palette.primary.main}`,
          backgroundColor: palette.lightTen,
          color: palette.primary.main,
          "&:hover": {
            backgroundColor: 'transparent',
            border: `1px solid ${palette.primary.main}`,
          }
        },
      }
    }
  },

  MuiListItemButton: {
    styleOverrides: {
      root: {
        color: palette.lightBlack,
        borderBottom: '2px solid transparent',
        fontSize: '14px',
        fontWeight: '500',

        "&:hover": {
          backgroundColor: 'transparent',

          "&:after": {
            content: '""',
            borderBottom: `2px solid ${palette.primary.main}`,
            position: 'absolute',
            height: '2px',
            width: '100%',
            bottom: '-10px',
            left: '0',
          }
        },
        '&.Mui-selected': {
          backgroundColor: 'transparent',
          fontWeight: '600',
          color: palette.primary.main,
          "&::after": {
            content: '""',
            borderBottom: `2px solid ${palette.primary.main}`,
            position: 'absolute',
            height: '2px',
            width: '100%',
            bottom: '-10px',
            left: '0',
          },
          "&:hover": {
            backgroundColor: 'transparent',
          },
        }
      }
    }
  },

  MuiPaper: {
    styleOverrides: {
      root: {
        boxShadow: 'none',

        "& .MuiPickersLayout-contentWrapper": {
          "& .MuiDayCalendar-weekDayLabel , .MuiPickersDay-root , .MuiPickersYear-yearButton": {
            fontSize: '14px',
          }
        }
      }
    }
  },

  MuiTable: {
    styleOverrides: {
      root: {
        fontSize: '14px',
        boxShaodw: 'none',

        th: {
          fontWeight: '600',
          borderBottom: '0.5px solid rgba(0, 0, 0, 0.12)'
        },

        td: {
          fontWeight: '400',
        }
      }
    }
  },

  MuiListItem: {
    styleOverrides: {
      root: {
        fontSize: '16px',
      }
    }
  },

  MuiList: {
    styleOverrides: {
      root: {
        border: '1px solid rgba(0, 0, 0, 0.12)'
      }
    }
  },


  MuiAppBar: {
    styleOverrides: {
      root: {
        backgroundColor: palette.white,
        boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.07)',
        borderBottom: 'transparent',
        borderWidth: '1px',
        "&.Mui-focused": {
          borderBottom: palette.primary.main,
        }
      }
    }
  },

  MuiFormControlLabel: {
    styleOverrides: {
      root: {
        '& .MuiFormControlLabel-label': {
          width: '100%',
          fontSize: '14px',
          color: palette.black
        }
      }
    }
  },

  MuiFormHelperText: {
    styleOverrides: {
      root: {
        fontSize: '12px',
        marginLeft: '0',
      }
    }
  },

  MuiAccordion: {
    styleOverrides: {
      root: {
        padding: '0',
        borderRadius: '4px',

        '& .MuiAccordionSummary-content': {
          marginTop: '0px',
          marginBottom: '0px',
          padding: '0',

          '&.Mui-expanded': {
            margin: "0 0",
          },
        },

        "& .MuiAccordionSummary-root": {
          padding: '0',

          '&.Mui-expanded': {
            minHeight: '48px',
            margin: "0 0",
          },
        },

        '& .MuiAccordionDetails-root': {
          padding: "10px 0 0 0",
          borderTop: '0.5px solid rgba(0, 0, 0, 0.12)',
        },
      }
    }
  },
}

export default components;